const PREFIX = 'saloon-pos-catalog:'

/**
 * @param {number | null} branchId
 * @param {'categories' | 'services'} kind
 * @param {number | null} [categoryId]
 */
function cacheKey(branchId, kind, categoryId = null) {
  return `${PREFIX}${branchId ?? 'none'}:${kind}:${categoryId ?? 'all'}`
}

/**
 * @param {number | null} branchId
 * @param {'categories' | 'services'} kind
 * @param {unknown} data
 * @param {number | null} [categoryId]
 */
export function savePosCatalogCache(branchId, kind, data, categoryId = null) {
  try {
    window.localStorage.setItem(
      cacheKey(branchId, kind, categoryId),
      JSON.stringify({ saved_at: new Date().toISOString(), data }),
    )
  } catch {
    // ignore quota errors
  }
}

/**
 * @param {number | null} branchId
 * @param {'categories' | 'services'} kind
 * @param {number | null} [categoryId]
 */
export function loadPosCatalogCache(branchId, kind, categoryId = null) {
  try {
    const raw = window.localStorage.getItem(cacheKey(branchId, kind, categoryId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed?.data) ? parsed.data : null
  } catch {
    return null
  }
}

export function isBrowserOffline() {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}
